// extracted by mini-css-extract-plugin
module.exports = {"lia-component-edit-mode":"QuiltComponent_lia-component-edit-mode__0nCcm"};